<template>
  <div>
    <span
      v-if="loading"
      class="loadingres mr-2 ml-2 spinner-border loading-spinner"
    ></span>
     <div class="p-2 m-3 rounded bg-danger"
        v-if="messageerror">
        <small class="text-white">{{messageerror}}</small>
      </div>
    <div class="form-group px-3 valid featured" v-if="!loading">
      <label>{{ $t("lang.calendar.calendarlist") }}</label>
      <IndustrySearch
        :multiple="true"
        :fromOrder="true"
        :option_list="calendarTypes"
        :default_values="calendarSelected"
        @closed="updated"
      />

      <div class="form-group mt-5 valid featured">
        <label>{{ $t("lang.calendar.calendarselected") }}</label>
        <select class="form-control" v-model="choose" @change="updateChoose()">
          <option
            v-for="calendar in calendarlist"
            :key="calendar.id"
            :value="calendar.id"
            v-if="!calendar.read_only"
          >
            {{ calendar.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
import { myCalendarService } from "@/_services";
import IndustrySearch from "../AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
export default {
  data() {
    return {
      calendarTypes: [],
      calendarSelected: [],
      calendarlist: [],
      messageerror:"",
      choose: "",
      loading: false
    };
  },
  props: {
    account_id: [String],
    calendar_select: [String],
    calendar_ids: [Array]
  },
  components: {
    IndustrySearch
  },
  created() {
    this.loading = true;
    this.getAllCalendars();
  },
  mounted() {},
  computed: {},
  methods: {
    getAllCalendars() {
      myCalendarService.getCalendars(this.account_id).then(async res => {
        let type = typeof res;
        if(type === 'object'){
          
          res.map(item => {
            item.label = item.name;
          });
          this.calendarTypes = res;
          this.calendarSelected = [];

          if(res.type !== undefined && res.type == 'invalid_request_error'){
            this.loading = false
            this.messageerror = res.message
          }else{
            res.map(item => {
              item.label = item.name;
            });
            this.calendarTypes = res;
            if (this.calendar_ids != null && this.calendar_ids.length > 0) {
              this.choose = this.calendar_select;

              this.calendar_ids.forEach(async item => {
                const resultado = await this.calendarTypes.find(
                  element => element.id === item
                );

                this.calendarSelected.push(resultado.id);
                this.calendarlist.push(resultado);
              });
            }else{  
              res.forEach((e)=>{
                if(e.is_primary){
                   this.calendarSelected.push(e.id);
                    this.calendarlist.push(e)
                    this.choose = e.id
                  }
                
              })

            }
            this.loading = false;
          }
           this.loading = false;
        }
          

       
      },
      (error)=>{
        if(error == 'stop'){
          window.location.reload();
        }
      });
    },

    updated(event) {
      if (event.length > 0) {
        this.calendarSelected = [];
      }else{
        this.choose = "";
        this.updateChoose();
      }
      event.map(item => {
        this.calendarTypes.forEach(element => {
          if (element.id == item) {
            this.calendarSelected.push(element);
          }
        });
      });
      this.calendarlist = this.calendarSelected;
      this.$emit("updated", this.calendarSelected);
    },
    updateChoose() {
      this.$emit("updateSelected", this.choose);
    }
  }
};
</script>
<style scoped></style>
